// extracted by mini-css-extract-plugin
module.exports = {"standardLang":"LanguageController_standardLang__3DV_o","highlightLang":"LanguageController_highlightLang__3yp4X"};